import LendioBootstrapToast from "~/components/bootstrap/LendioBootstrapToast";
import LendioBootstrapTooltip from "~/components/bootstrap/LendioBootstrapTooltip";

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.component('LendioBootstrapToast', LendioBootstrapToast)
  vueApp.component('LendioBootstrapTooltip', LendioBootstrapTooltip)
})
